module.exports = __webpack_public_path__ + "img/con_7.890a6cd9.svg";